import { useState } from 'react';
import { IBrandAgg } from '../search-filter/search-filter';
import styles from './search-filter-mobile.module.css';
export default function SearchFilterMobile(props: 
		{
			brandAgg: IBrandAgg[],
			priceAgg: any[],
			query: string | undefined,
			totalRows: number,
			setValidPriceRanges: Function,
			validPriceRanges: any[],
			validBrands: string[],
			setValidBrands: Function
			defaultSortOrder: string
			setDefaultSortOrder: Function
		}) {
		
	const [visible, setVisible] = useState(false);
	const [selectedPrice, setSelectedPrice] = useState<any>([]);
	return (
		<div className="showInMobile">
			<div style={{display: 'flex', justifyContent: 'space-between', padding: '8px', alignItems: 'center'}}>
				<div>Antall treff: <strong>{props.totalRows}</strong></div>
				<button className={styles.filterTopBtn} onClick={() => setVisible(true)}>Filter</button>
				<select style={{fontSize: '16px'}} onChange={(e) => {
					e.stopPropagation();
					const sortOrder = e.target.value.toString();
					props.setDefaultSortOrder(sortOrder);
				}}>
					<option value="relevance">Mest relevant</option>
					<option value="priceASC">Pris lav til høy</option>
					<option value="priceDESC">Pris høy til lav</option>
				</select>				
			</div>
			{visible ? <div className={styles.moduleFilterWrapper}>
				<div className={styles.moduleFilterInner}>
					<div className={styles.moduleFilterInnerTop}>
						Filtrer søket | Søkeord <em>"{props.query}"</em><br/>
					</div>
				<div style={{paddingLeft: '16px', height: '100%', paddingTop: '32px', overflow: 'scroll'}}>
				<section>
					<div className={styles.header}>Pris</div>			
					{props.priceAgg.map((agg: any, index: number) => {
						return (
							<div key={agg?.id + index.toString()} className={styles.checkboxWrapper}>
								<input type="checkbox" checked={props.validPriceRanges.findIndex(a => {
									return a.min === agg._id && a.max === (props.priceAgg[index + 1]?._id - 1 || 990000)
								}) > -1 } id={agg._id}  name={agg._id} onChange={(() => {
									if (props.validPriceRanges.findIndex((r: {min: number, max: number}) => r.min === agg._id) > -1) {
										const newValidPriceRanges = props.validPriceRanges.filter((range: any) => range.min !== agg._id);
										props.setValidPriceRanges(newValidPriceRanges);
									} else {
										props.setValidPriceRanges([...props.validPriceRanges, {
											min: agg._id,
											max: props.priceAgg[index + 1]?._id - 1 || 990000
										}]);
										setSelectedPrice([agg._id, props.priceAgg[index + 1]?._id - 1 || 990000]);
									}
								})} />
								<label className={styles.aggLabel} htmlFor={agg._id} >{agg._id} - {props.priceAgg[index + 1]?._id - 1 || ''} ({agg.count})</label>
							</div>
						)
					})}				
				</section>
				<br/>	
				<section>
					<div  className={styles.header}>MERKER</div>	
					{props.brandAgg
					.map((agg: any, index: number) => {
						return (
							<div key={agg?.id + index.toString()} className={styles.checkboxWrapper}>
								<input type="checkbox" checked={props.validBrands.indexOf(agg._id) > -1} id={agg._id}  name={agg._id} onChange={() => {
									if (props.validBrands.findIndex((r: string) => r === agg._id) > -1) {
										const newValidAffiliates = props.validBrands.filter((a: string) => a !== agg._id);
										props.setValidBrands(newValidAffiliates);
									} else {
										props.setValidBrands([...props.validBrands, agg._id]);
									}
								}} />
								<label className={styles.aggLabel} htmlFor={agg._id} >{`${agg._id.substring(0,1).toUpperCase()}${agg._id.substring(1,agg._id.length).toLowerCase()}`} ({agg.numberOfProducts})</label>
							</div>
						)
					})}
				</section>
					</div>
					<div className={styles.moduleFilterInnerBottom}>
						<button className={styles.filterBtn} onClick={() => setVisible(false)}>
							Vis alle {props.totalRows} treff
						</button>
					</div>
				</div>
			</div>
			: <></>}
		</div>
	)
}